import { api } from "./configs/axiosConfigs"

export const ExternalMaintenanceAPI = {
    get: async (data?: any) => {
        const response = await api.get(
            '/externalMaintenance',
            {
                params: {
                    ...data
                }
            }
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
    report: async (data?: any) => {
        const response = await api.get(
            '/externalMaintenance/report',
            {
                params: {
                    ...data
                }
            }
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
    create: async (data: any) => {
        const response = await api.post(
            '/externalMaintenance/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
    edit: async (id: number, data: any) => {
        const response = await api.patch(
            `/externalMaintenance/${id}`,
            {
                ...data
            }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },
    delete: async (id: number) => {
        const response = await api.delete(
            `/externalMaintenance/${id}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },
}